class MeetingApi {
    constructor(fetchService) {
        this.fetchService = fetchService;
    }
    getMeetings({ companyId, locationId, meetingId }) {
        return this.fetchService.get(`/companies/${companyId}/locations/${locationId}/meetings/${meetingId}`);
    }
}
export default MeetingApi;
